import { clearOfflineData } from './offlineSync.js'

const TOKEN_KEY = 'nq_token'
const CHILD_TOKEN_KEY = 'nq_child_token'
const CURRENT_CHILD_KEY = 'nq_current_child'
const ONBOARDING_KEY = 'nq_onboarding_done'

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setStoredToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearStoredToken() {
  localStorage.removeItem(TOKEN_KEY)
  clearOfflineData() // clear offline data on parent logout
}

// Child token (family-scoped, set via QR/link)
// Uses localStorage so the token survives PWA restarts and page refreshes
// on dedicated child devices. The token is family-scoped (not user-specific)
// and expires after 90 days, which is acceptable for a shared child tablet.
export function getChildToken() {
  return localStorage.getItem(CHILD_TOKEN_KEY)
}

export function setChildToken(token) {
  localStorage.setItem(CHILD_TOKEN_KEY, token)
}

export function clearChildToken() {
  localStorage.removeItem(CHILD_TOKEN_KEY)
  localStorage.removeItem(CURRENT_CHILD_KEY)
  clearOfflineData() // clear offline data on child logout
}

// Which child is currently "playing" on this device
export function getCurrentChildId() {
  return localStorage.getItem(CURRENT_CHILD_KEY)
}

export function setCurrentChildId(id) {
  localStorage.setItem(CURRENT_CHILD_KEY, id)
}

export function getTokenPayload() {
  // Child token takes precedence on child devices
  const token = getChildToken() || getStoredToken()
  if (!token) return null

  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    return JSON.parse(atob(payload))
  } catch {
    return null
  }
}

export function isChildDevice() {
  return !!getChildToken()
}

export function getIsAdmin() {
  return getTokenPayload()?.isAdmin === true
}

export function isOnboardingDone() {
  return localStorage.getItem(ONBOARDING_KEY) === 'true'
}

export function markOnboardingDone() {
  localStorage.setItem(ONBOARDING_KEY, 'true')
}
